export { default } from 'next/config';
